import Route from '@ember/routing/route'

export default class TileWidgetRoute extends Route {}
